// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DHhh7{font-family:Inter,sans-serif;font-weight:700;font-style:normal;font-size:20px;line-height:125%;letter-spacing:0px;text-align:center;margin-bottom:6px}
.pPLI_{font-family:Inter,sans-serif;font-weight:400;font-style:normal;font-size:14px;line-height:150%;letter-spacing:0px;text-align:center;color:#334155;-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;margin-bottom:0;min-height:63px}
.erkbf{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:auto;padding-top:10px}
.QPZou{padding:6px 40px !important;min-width:auto !important;border-radius:6px !important;font-size:15px !important;font-weight:600 !important}
.QPZou:hover{font-size:15px !important;font-weight:600 !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardTitle": `DHhh7`,
	"cardDescription": `pPLI_`,
	"cardActionRow": `erkbf`,
	"startButton": `QPZou`
};
module.exports = ___CSS_LOADER_EXPORT___;
